import React, { useState, useEffect } from "react";
import { getMyResult } from "../../Apis/endpoints";
import Result_feed from "./Result_feed"; // Import Result_feed

const MyResult = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);
  const profileId = localStorage.getItem("user_id");

  useEffect(() => {
    const fetchResults = async () => {
      try {
        if (!profileId) return;
        // console.log("Fetching results...");

        const data = await getMyResult(profileId);
        if (Array.isArray(data)) {
          setResults(data);
        } else {
          setResults([]); 
        }
        
      } catch (error) {
        console.error("Error fetching results:", error);
      }
    };

    fetchResults();
  }, [profileId]);

  // Filter results by video name
  const filteredResults = results.filter((result) =>
    result.video_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <div className="flex items-center justify-between m-5">
        <span className="text-[#002952] text-xl font-bold">My Results</span>
        <input
          type="text"
          placeholder="Search by Video Name..."
          className="w-full p-2 rounded-md border border-gray-400 focus:outline-none focus"
          style={{
            padding: "0.4rem 1rem",
            maxWidth: "300px",
            borderRadius: "50px",
            fontSize: "16px",
            marginLeft: "5px",
            border: "1px solid #C9C9C9",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Render the result feed component */}
      <Result_feed results={filteredResults} />

      {children}
    </div>
  );
};

export default MyResult;
